import { Component, HostListener } from '@angular/core';
import { CmsBannerComponent, CmsService, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { Overlay } from '@angular/cdk/overlay';
import { ExternalLinkModalComponent } from '../../cms-common/external-link-modal/external-link-modal.component';
import { ContentService } from '../../spartacus/services/content.service';

@Component({
    selector: 'app-sixth',
    templateUrl: './sixth.component.html',
    styleUrls: ['./sixth.component.scss'],
    standalone: false
})
export class SixthComponent {
  // ref2 : Observable<any> = this.cmsService.getComponentData('SeqirusInfluenzaPlusSixthComponent');
  ref2 : Observable<any> = this.bannerComponent.data$;
  popupdata: any;
  constructor(
    private cmsService:CmsService,
    protected config: OccConfig,
    public bannerComponent: CmsComponentData<CmsBannerComponent>,
    private dialog: MatDialog,
    private overlay: Overlay,
    protected paraService: ContentService
  ) {
  }

  ngOnInit() {
    this.paraService.getNavigation('TIVcPopUp').subscribe((res) => {
      this.popupdata = res;
    });
  }
  @HostListener('click', ['$event'])
  onClick(event: Event) {
    const link = (event.target as HTMLElement)?.closest('.externaltivc') as HTMLAnchorElement | null;
    if (!link?.href) {
      return;
    }
    event.preventDefault();
    this.openExternalLinkModal(link.href);
  }

  openExternalLinkModal(url?: string) {
    this.dialog.open(ExternalLinkModalComponent, {
      scrollStrategy: this.overlay.scrollStrategies.noop(),
      data: { popupdata: this.popupdata, url },
      disableClose: true,
      hasBackdrop: true,
      autoFocus: false,
      restoreFocus: true,
      panelClass: 'external-link-dialog-panel',
      backdropClass: 'custom-backdrop'
    });
  }
}
